<template>
  <div class="page">
    <div
      class="item"
      v-for="(item, index) in list"
      :key="index"
      @click="handleAppClick(item)"
    >
      <div class="text-wrap">
        <div class="title" v-text="item.appName"></div>
        <div class="link-wrap">
          <span class="link-text">进入</span>
          <van-icon class="arrow" name="arrow" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { thirdAppListGet, userAuth } from "@/api/common";
import { STATUS_CODE_OK } from "@/config";
import { queryStringParameter, hasLoginCheck, logTrace } from "@/utils";
export default {
  name: "SeatApply",
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.handleListGet();
  },
  methods: {
    // 获取数字阅读应用列表
    async handleListGet() {
      const that = this;
      let { data } = await thirdAppListGet({
        appCategory: "7",
      });
      if (data.code === STATUS_CODE_OK) {
        that.list = data.data;
      }
    },
    // 点击第三方应用
    async handleAppClick(item) {
      const that = this;
      if (item.appExtUserFlag === "Y") {
        // 需要用户授权
        hasLoginCheck({
          tip: "进入此应用前，请先登录",
          path: that.$route.fullPath,
          callBack: async () => {
            // 用户已经登录，则调用接口获取authCode
            let { data } = await userAuth({
              id: item.id,
            });
            if (data.code === STATUS_CODE_OK) {
              logTrace({
                prefixUrl: that.$route.path,
                prefixUrlName: that.$route.meta.name,
                requestUrl: item.appRedirectUrl,
                rquestUrlName: item.appName,
                actionType: "page",
                actionTypeCode: "1",
                actionTypeDesc: "页面跳转",
              });
              // 跳转到第三方应用
              window.location.href = queryStringParameter(
                item.appRedirectUrl,
                "authCode",
                data.data.authCode
              );
            }
          },
        });
      } else {
        // 不需要用户授权
        if (item.routerFlag === "1") {
          // 内部url
          that.$router.push({
            path: item.appRedirectUrl,
          });
        } else {
          logTrace({
            prefixUrl: that.$route.path,
            prefixUrlName: that.$route.meta.name,
            requestUrl: item.appRedirectUrl,
            rquestUrlName: item.appName,
            actionType: "page",
            actionTypeCode: "1",
            actionTypeDesc: "页面跳转",
          });
          // 外部的url
          window.location.href = item.appRedirectUrl;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  background-color: #f7f8fa;
  padding: 10px;
  .item {
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 10px;
    background-color: #fff;
    display: flex;
    align-items: flex-start;
    .icon {
      width: 140px;
      height: 85px;
      border-radius: 4px;
      margin-right: 10px;
      object-fit: cover;
    }
    .text-wrap {
      display: flex;
      width: 0;
      flex: 1;
      align-items: center;
      justify-content: space-between;
      .title {
        font-size: 18px;
      }
      .desc {
        padding-top: 5px;
        color: #999;
      }
      .link-wrap {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 12px;
        padding-top: 2px;
        color: #1989fa;
      }
    }
  }
}
</style>
